import type { FaireProductEntity } from "../../entity_types/product";

export const p_enyc5e7h44: FaireProductEntity = {
  token: "p_enyc5e7h44",
  type: "product",
  name: "Organic Perineal Balm",
  brandToken: "b_1q5xt82q",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7307b4da173ea04d6aa5baad242d001a2066b45f5898c34f70fbffd4ac9e466b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f91f7f3c787b7a720dd6ce977fc27a0c8218b3ad219946f858846dcca0960bf.jpeg",
    "https://cdn.faire.com/fastly/73b7d2ebfebd6216f8a95c9cadc2fb13633a118a37946302c4e3a16d7bbba00a.jpeg",
    "https://cdn.faire.com/fastly/09c259ef72dd2a165073a9a4d7b1d17b13dcbace5544b812189ae726d727be05.jpeg",
    "https://cdn.faire.com/fastly/eb88dd2373b662d9d62592f4e0113ea7afa600a5e2dde4ea5c124ef6a844fdc9.jpeg",
    "https://cdn.faire.com/fastly/f88bd17a48fa275d3ccec4d9b89f27b774e9c1b7acdf12f394c04a1c12ae2692.jpeg",
    "https://cdn.faire.com/fastly/c90c3fc0d72912f70e8f8dd480936ce9a586341da8f5315de6392f2fde13a4af.jpeg",
    "https://cdn.faire.com/fastly/9eb7345ebc3d7f154c289796d0a0549e51795fbbecfd70f0f6178d6b34c32ee0.jpeg",
  ],
  priceDollars: 11.07,
  description:
    "Has your pep lost her step? Organic Perineal Balm to the rescue, with lasting, cooling “down there” relief that’s safe and effective For Everyone and Their Mother®, including postpartum perineal care and pregnancy. Organic Perineal Balm boasts an exclusive herbal blend of organic witch hazel and other rich organic botanicals — all traditionally used to soothe and relieve nether region discomfort for grown-ups of any age.\n\n\nApply to 2-3 times a day and you'll be sitting pretty in no time. Store in the fridge for extra cooling. Need a little more help? Here’s how to use perineal balm. Don’t worry, it’s easy!\n\n * Formulated specifically for pregnant and postpartum women, but safe and effective For Everyone & Their Mother®. \n * Certified by Oregon Tilth, Leaping Bunny Certified, and Plastic Neutral \n * No petroleum, artificial fragrance or artificial preservatives. \n * Dermatologist tested for irritation. \n * Use with Herbal Sitz Bath and Herbal Perineal Spray for the ultimate trifecta of Take Care Down There® soothing postpartum relief. \n\n",
  tags: [],
  msrpDollars: 22.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:32.072Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
